import { ArdoqId, GroupType, GroupingRule } from '@ardoq/api-types';
import { EnhancedScopeData } from '@ardoq/data-model';
import { invariant } from '@ardoq/invariant';
import { enhancedScopeDataOperations } from './enhancedScopeDataOperations';

const parentBasedGroupingTypes = [GroupType.PARENT, GroupType.PARENT_ALL];

export const isParentBasedGrouping = (groupBy?: GroupingRule) =>
  groupBy && parentBasedGroupingTypes.includes(groupBy.type);

export const isParentAllGrouping = (groupingRule: GroupingRule) =>
  groupingRule.type === GroupType.PARENT_ALL;

export const isParentTypeGrouping = (groupingRule: GroupingRule) =>
  groupingRule.type === GroupType.PARENT;

const isComponentAffectedByParentGroupingRule = (
  scopeData: EnhancedScopeData,
  componentId: ArdoqId,
  groupingRules: GroupingRule[]
) => {
  const componentAttributes = enhancedScopeDataOperations.getComponent(
    scopeData,
    componentId
  );
  invariant(componentAttributes, 'Missing component in enhancedScopeData', {
    componentId,
  });

  if (groupingRules.some(isParentAllGrouping)) {
    return true;
  }

  const parentGroupingRuleTypeIds = groupingRules
    .filter(isParentTypeGrouping)
    .map(groupingRule => groupingRule.targetId);

  const componentTypeId =
    enhancedScopeDataOperations.getComponentTypeByComponentId(
      scopeData,
      componentId
    ).id;

  if (!parentGroupingRuleTypeIds.length) {
    return false;
  }

  return parentGroupingRuleTypeIds.includes(componentTypeId);
};

export const isIncludedInScopeByParentGroupingRule = (
  scopeData: EnhancedScopeData,
  componentId: ArdoqId,
  groupBys: GroupingRule[] = []
) =>
  groupBys.some(isParentBasedGrouping) &&
  isComponentAffectedByParentGroupingRule(scopeData, componentId, groupBys);

export const enhanceTargetIdWithWorkspaceId = (
  groupingRule: GroupingRule,
  workspaceId?: ArdoqId
) => {
  switch (groupingRule.type) {
    case GroupType.REFERENCE: {
      const targetId = `${groupingRule.workspaceId ?? workspaceId}-${
        groupingRule.targetId
      }`;
      return {
        ...groupingRule,
        targetId,
      };
    }
  }
  return { ...groupingRule, workspaceId: workspaceId ?? '' };
};
